<template>
    <component :is="noteTypeComponent" :noteId="noteId" @close="close" />
</template>

<script>
import { noteTypes } from "@/config/index.js";
import PlainTextBuilder from "./types/build/PlainTextBuilder";
import SoapBuilder from "./types/build/SoapBuilder";

export default {
    name: "note-builder",
    props: {
        type: {
            type: Number,
            required: true,
        },
        noteId: {
            type: String,
            default: null,
        },
    },
    computed: {
        noteTypeComponent() {
            switch (this.type) {
                case noteTypes.plainText:
                    return PlainTextBuilder;
                case noteTypes.soap:
                    return SoapBuilder;
            }
            return null;
        },
    },
    methods: {
        close() {
            this.$emit("close");
        },
    },
};
</script>